import AgentInsightsHub from './AgentInsightsHub';

const MessagesPage = () => {
  return <AgentInsightsHub />;
};

export default MessagesPage;